import { useState, useEffect } from 'react';
import { billService } from '../services/billService.ts';
import { Bill, BillStatus } from '../types/bill.ts';

export const useBills = () => {
  const [bills, setBills] = useState<Bill[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    fetchBills();
  }, []);

  const fetchBills = async () => {
    try {
      setLoading(true);
      const data = await billService.fetchBills();
      setBills(data);
      setError(null);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  const updateBill = async (id: string, status: BillStatus) => {
    try {
      const updatedBill = await billService.updateBillStatus(id, status);
      setBills(bills.map(bill => bill.id === id ? updatedBill : bill));
    } catch (err) {
      setError(err as Error);
      throw err;
    }
  };

  const deleteBill = async (id: string) => {
    try {
      await billService.deleteBill(id);
      setBills(bills.filter(bill => bill.id !== id));
    } catch (err) {
      setError(err as Error);
      throw err;
    }
  };

  return {
    bills,
    loading,
    error,
    updateBill,
    deleteBill,
    refresh: fetchBills,
  };
};
